import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import { injectIntl } from 'components/Intl';
import { getSelector } from 'redux/selectors';
import { setConfirmAction } from 'redux/ui/actions';

const ConfirmDialog = ({
  confirmAction,
  formatMessage,
  setConfirmAction,
}) => {
  if (!confirmAction.get('action')) return null;

  return (
    <Dialog open={!!confirmAction.get('action')}>
      <DialogContent>
        {confirmAction.get('description')}
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          onClick={() => setConfirmAction({ action: null })}
          variant="text"
        >
          {formatMessage('Cancel')}
        </Button>
        <Button
          color="primary"
          onClick={() => {
            confirmAction.get('action')();
            setConfirmAction({ action: null });
          }}
          variant="contained"
        >
          {formatMessage('OK')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ConfirmDialog.propTypes = {
  confirmAction: ImmutablePropTypes.mapContains({
    action: PropTypes.func,
    description: PropTypes.string,
  }).isRequired,

  formatMessage: PropTypes.func.isRequired,
  setConfirmAction: PropTypes.func.isRequired,
};

/* istanbul ignore next */
const mapStateToProps = state => ({
  confirmAction: getSelector('ui', 'confirmAction')(state),
});

/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  setConfirmAction: payload => dispatch(setConfirmAction(payload)),
});

const wrappedConfirmDialog =
  connect(mapStateToProps, mapDispatchToProps)(injectIntl(ConfirmDialog));
wrappedConfirmDialog.displayName = 'ConfirmDialog';

export default wrappedConfirmDialog;
